import { api } from "@/lib/api";

// Resumable chunked upload: 8 MB parts, each retried up to 4 times; server assembles + validates on complete.
export const chunkedUpload = async (file, meta, onProgress) => {
  const init = await api.post("/media/upload/init", { filename: file.name, size: file.size, ...meta });
  const { upload_id, chunk_size, total_chunks } = init.data;
  const started = Date.now();
  for (let i = 0; i < total_chunks; i++) {
    const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
    let attempt = 0;
    for (;;) {
      try {
        await api.put(`/media/upload/${upload_id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" }, timeout: 180000 });
        break;
      } catch (e) {
        if (++attempt > 4) throw new Error(`Upload failed on part ${i + 1}/${total_chunks} after 4 retries — check your connection and try again.`);
        await new Promise((r) => setTimeout(r, 1500 * attempt));
      }
    }
    const done = Math.min(file.size, (i + 1) * chunk_size);
    const elapsed = (Date.now() - started) / 1000;
    onProgress?.({ pct: Math.round((done / file.size) * 100), done, total: file.size, rate: done / Math.max(elapsed, 0.1), eta: (file.size - done) / Math.max(done / Math.max(elapsed, 0.1), 1) });
  }
  onProgress?.({ pct: 100, done: file.size, total: file.size, finalizing: true });
  const res = await api.post(`/media/upload/${upload_id}/complete`, {}, { timeout: 1800000 });
  return res.data;
};
